import { useMemo } from 'react';
import { useGetEditOrActual } from '../../CampaignSettings/selectors/useGetEditOrActual';

export const useSplitTestNameSelector = (id: string) => {
  const state = useGetEditOrActual();
  return useMemo(() => state.splitTests[id]?.name, [id, state]);
};
